import { Box, Divider, Typography } from '@mui/joy'
import { AttachFile } from '@mui/icons-material'
import { FetchedEmailAttachment } from '../../../../../../../../../../../../types/fetched-email/types'
import { EmailAttachment } from './components'

interface EmailAttachmentsProps {
    attachments: FetchedEmailAttachment[]
    messageId: string
    grantId: string
}

export default function EmailAttachments({ attachments, messageId, grantId }: EmailAttachmentsProps) {
    if (!attachments || attachments.length === 0) {
        return null
    }

    return (
        <>
            <Divider sx={{ mx: 2 }} />
            <Box sx={{ p: 2, pt: 1.5 }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        mb: 1.5,
                    }}
                >
                    <AttachFile
                        sx={{
                            fontSize: '1.1rem',
                            color: 'text.tertiary',
                        }}
                    />
                    <Typography
                        level="title-sm"
                        sx={{
                            fontWeight: 600,
                            color: 'text.primary',
                        }}
                    >
                        Attachments ({attachments.length})
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                        gap: 1.5,
                        '& > *': {
                            '--Card-padding': '0px',
                            '--Card-radius': 'var(--joy-radius-md)',
                        },
                    }}
                >
                    {attachments.map((attachment) => (
                        <EmailAttachment key={attachment.id} attachment={attachment} messageId={messageId} grantId={grantId} />
                    ))}
                </Box>
            </Box>
        </>
    )
}
